import { Image } from 'src/components/ui/Image'
import Slider from 'src/components/ui/Slider/Slider'
import { useMobile } from 'src/hooks/useMobile'

interface CardItem {
  icon?: string
  title: string
  description: string
}

interface BannerWithCardsProps {
  bannerImage: string
  cards: CardItem[]
}

const CartaoPresenteBannerWithCards: React.FC<BannerWithCardsProps> = ({
  bannerImage,
  cards,
}) => {
  const { isMobile } = useMobile()

  return (
    <section className="w-full max-w-[1440px] mx-auto flex flex-col md:flex-row justify-around my-[100px] gap-6">
      <div className="w-full md:w-[370px] h-[500px]">
        <Image src={bannerImage} alt="Banner" className="w-full h-full " />
      </div>

      {isMobile ? (
        <div className="px-4">
          <Slider
            title=""
            itemQuantity={cards.length}
            skeletonStyles="w-[270px] h-[240px]"
            hasScrollbar={false}
          >
            {cards.slice(0, 4).map((card, i) => (
              <li key={i}>
                <div className="flex flex-col bg-white border border-[#D9DDE1] p-6 h-[240px] md:w-[270px] w-[340px]">
                  {card.icon && (
                    <Image
                      src={card.icon}
                      alt={card.title}
                      className="w-8 h-8 mb-[20px]"
                    />
                  )}
                  <h3 className="text-lg font-semibold text-[#101010]">
                    {card.title}
                  </h3>
                  <p className="text-[#616161] text-base">{card.description}</p>
                </div>
              </li>
            ))}
          </Slider>
        </div>
      ) : (
        <div className="grid px-4 md:grid-cols-2 gap-4">
          {cards.slice(0, 4).map((card, i) => (
            <div
              key={i}
              className="flex flex-col bg-white rounded-lg border border-[#D9DDE1] p-6 h-[240px] w-[370px]"
            >
              {card.icon && (
                <Image
                  src={card.icon}
                  alt={card.title}
                  className="w-8 h-8 mb-[20px]"
                />
              )}
              <h3 className="text-lg font-semibold text-[#101010]">
                {card.title}
              </h3>
              <p className="text-[#616161] text-base">{card.description}</p>
            </div>
          ))}
        </div>
      )}
    </section>
  )
}

export default CartaoPresenteBannerWithCards
